// Curated list of major Indian cities (with State) for the loan-cockpit
// vehicle-location combobox. Stored & displayed as "City, State" so reps can
// disambiguate quickly during a call.
const INDIAN_CITIES = [
  'Mumbai, Maharashtra', 'Pune, Maharashtra', 'Nagpur, Maharashtra', 'Nashik, Maharashtra',
  'Thane, Maharashtra', 'Aurangabad, Maharashtra', 'Solapur, Maharashtra', 'Kolhapur, Maharashtra',
  'Amravati, Maharashtra', 'Sangli, Maharashtra', 'Navi Mumbai, Maharashtra',
  'New Delhi, Delhi', 'Delhi, Delhi',
  'Bengaluru, Karnataka', 'Mysuru, Karnataka', 'Hubli, Karnataka', 'Mangaluru, Karnataka',
  'Belagavi, Karnataka', 'Kalaburagi, Karnataka', 'Davanagere, Karnataka', 'Ballari, Karnataka',
  'Tumakuru, Karnataka', 'Shivamogga, Karnataka', 'Udupi, Karnataka',
  'Hyderabad, Telangana', 'Warangal, Telangana', 'Nizamabad, Telangana', 'Karimnagar, Telangana',
  'Khammam, Telangana',
  'Visakhapatnam, Andhra Pradesh', 'Vijayawada, Andhra Pradesh', 'Guntur, Andhra Pradesh',
  'Nellore, Andhra Pradesh', 'Kurnool, Andhra Pradesh', 'Tirupati, Andhra Pradesh',
  'Rajahmundry, Andhra Pradesh', 'Kakinada, Andhra Pradesh', 'Kadapa, Andhra Pradesh',
  'Chennai, Tamil Nadu', 'Coimbatore, Tamil Nadu', 'Madurai, Tamil Nadu', 'Tiruchirappalli, Tamil Nadu',
  'Salem, Tamil Nadu', 'Tirunelveli, Tamil Nadu', 'Tiruppur, Tamil Nadu', 'Erode, Tamil Nadu',
  'Vellore, Tamil Nadu', 'Thoothukudi, Tamil Nadu', 'Thanjavur, Tamil Nadu', 'Hosur, Tamil Nadu',
  'Dindigul, Tamil Nadu',
  'Kochi, Kerala', 'Thiruvananthapuram, Kerala', 'Kozhikode, Kerala', 'Thrissur, Kerala',
  'Kollam, Kerala', 'Kannur, Kerala', 'Alappuzha, Kerala', 'Palakkad, Kerala', 'Malappuram, Kerala',
  'Ahmedabad, Gujarat', 'Surat, Gujarat', 'Vadodara, Gujarat', 'Rajkot, Gujarat', 'Bhavnagar, Gujarat',
  'Jamnagar, Gujarat', 'Junagadh, Gujarat', 'Gandhinagar, Gujarat', 'Anand, Gujarat', 'Nadiad, Gujarat',
  'Morbi, Gujarat', 'Gandhidham, Gujarat', 'Mehsana, Gujarat',
  'Jaipur, Rajasthan', 'Jodhpur, Rajasthan', 'Udaipur, Rajasthan', 'Kota, Rajasthan', 'Bikaner, Rajasthan',
  'Ajmer, Rajasthan', 'Bhilwara, Rajasthan', 'Alwar, Rajasthan', 'Sikar, Rajasthan', 'Sri Ganganagar, Rajasthan',
  'Pali, Rajasthan', 'Bharatpur, Rajasthan',
  'Lucknow, Uttar Pradesh', 'Kanpur, Uttar Pradesh', 'Ghaziabad, Uttar Pradesh', 'Agra, Uttar Pradesh',
  'Varanasi, Uttar Pradesh', 'Meerut, Uttar Pradesh', 'Prayagraj, Uttar Pradesh', 'Noida, Uttar Pradesh',
  'Bareilly, Uttar Pradesh', 'Aligarh, Uttar Pradesh', 'Moradabad, Uttar Pradesh', 'Saharanpur, Uttar Pradesh',
  'Gorakhpur, Uttar Pradesh', 'Firozabad, Uttar Pradesh', 'Jhansi, Uttar Pradesh', 'Mathura, Uttar Pradesh',
  'Ayodhya, Uttar Pradesh',
  'Patna, Bihar', 'Gaya, Bihar', 'Bhagalpur, Bihar', 'Muzaffarpur, Bihar', 'Darbhanga, Bihar',
  'Purnia, Bihar', 'Begusarai, Bihar', 'Arrah, Bihar', 'Chapra, Bihar',
  'Kolkata, West Bengal', 'Howrah, West Bengal', 'Durgapur, West Bengal', 'Asansol, West Bengal',
  'Siliguri, West Bengal', 'Bardhaman, West Bengal', 'Malda, West Bengal', 'Kharagpur, West Bengal',
  'Bhopal, Madhya Pradesh', 'Indore, Madhya Pradesh', 'Jabalpur, Madhya Pradesh', 'Gwalior, Madhya Pradesh',
  'Ujjain, Madhya Pradesh', 'Sagar, Madhya Pradesh', 'Dewas, Madhya Pradesh', 'Satna, Madhya Pradesh',
  'Ratlam, Madhya Pradesh', 'Rewa, Madhya Pradesh',
  'Raipur, Chhattisgarh', 'Bhilai, Chhattisgarh', 'Bilaspur, Chhattisgarh', 'Korba, Chhattisgarh',
  'Durg, Chhattisgarh',
  'Bhubaneswar, Odisha', 'Cuttack, Odisha', 'Rourkela, Odisha', 'Sambalpur, Odisha', 'Berhampur, Odisha',
  'Chandigarh, Chandigarh',
  'Ludhiana, Punjab', 'Amritsar, Punjab', 'Jalandhar, Punjab', 'Patiala, Punjab', 'Bathinda, Punjab',
  'Mohali, Punjab', 'Hoshiarpur, Punjab', 'Pathankot, Punjab',
  'Faridabad, Haryana', 'Gurugram, Haryana', 'Panipat, Haryana', 'Ambala, Haryana', 'Yamunanagar, Haryana',
  'Rohtak, Haryana', 'Hisar, Haryana', 'Karnal, Haryana', 'Sonipat, Haryana', 'Panchkula, Haryana',
  'Dehradun, Uttarakhand', 'Haridwar, Uttarakhand', 'Roorkee, Uttarakhand', 'Haldwani, Uttarakhand',
  'Rudrapur, Uttarakhand',
  'Ranchi, Jharkhand', 'Jamshedpur, Jharkhand', 'Dhanbad, Jharkhand', 'Bokaro, Jharkhand', 'Deoghar, Jharkhand',
  'Guwahati, Assam', 'Silchar, Assam', 'Dibrugarh, Assam', 'Jorhat, Assam', 'Nagaon, Assam',
  'Srinagar, Jammu and Kashmir', 'Jammu, Jammu and Kashmir',
  'Shimla, Himachal Pradesh', 'Solan, Himachal Pradesh', 'Mandi, Himachal Pradesh',
  'Panaji, Goa', 'Margao, Goa', 'Vasco da Gama, Goa',
  'Agartala, Tripura', 'Imphal, Manipur', 'Shillong, Meghalaya', 'Aizawl, Mizoram',
  'Kohima, Nagaland', 'Itanagar, Arunachal Pradesh', 'Gangtok, Sikkim',
  'Puducherry, Puducherry', 'Port Blair, Andaman and Nicobar Islands',
  'Daman, Daman and Diu', 'Silvassa, Dadra and Nagar Haveli', 'Leh, Ladakh',
];

export const getIndianCities = () => INDIAN_CITIES;

export default INDIAN_CITIES;
